import { FC, PropsWithChildren } from "react";

import { daDK } from "@mui/x-date-pickers/locales";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { da } from "date-fns/locale";

import { LocalizationProvider as MuiLocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const LocalizationProvider: FC<PropsWithChildren> = ({ children }) => (
  <MuiLocalizationProvider
    localeText={daDK.components.MuiLocalizationProvider.defaultProps.localeText}
    dateAdapter={AdapterDateFns}
    adapterLocale={da}
  >
    {children}
  </MuiLocalizationProvider>
);

export default LocalizationProvider;
